import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';

import { API_URL } from '../../../constant';
import LoaderSpinner from '../../../components/LoaderSpinner';
import styles from '../help.module.scss';

const Installation = () => {
  const history = useHistory();
  const [content, setContent] = useState();

  useEffect(() => {
    async function getContent() {
      const token = localStorage.getItem('token');
      if (token) {
        let res;
        const config = {
          headers: {
            Authorization: `${token}`,
          },
        };
        const url = `${API_URL}/quiz/installation`;
        const promise = await fetch(url, config);
        if (promise.ok) res = await promise.json();
        if (res?.installations) setContent(res.installations);
      }
    }
    getContent();
  }, []);

  return (
    <div className={styles.installation}>
      {content ? (
        <>
          <div className={styles['header-desktop']}>
            <div className={styles.title}>
              <a onClick={() => history.goBack()}><BiArrowBack size={34} /></a>
              <h1>{"Aide à l'installation"}</h1>
            </div>
          </div>
          <ul>
            {content.map((d, i) => (
              <li key={`faq-${i}`}>
                <h4 dangerouslySetInnerHTML={{ __html: d.nom }} />
                <span dangerouslySetInnerHTML={{ __html: d.descriptif_long }} />
                {d.media.length > 0 && (
                  <>
                    {d.media.map((img, j) => (
                      <img key={`img-${i}-${j}`} src={`${d.mediaBaseUrl}${img.nom}`} />
                    ))}
                  </>
                )}
              </li>
            ))}
          </ul>
        </>
      ) : (
        <div className={styles.loader}><LoaderSpinner blue /></div>
      )}
    </div>
  );
};

export default Installation;
